import { AmbientLight, Color } from "three";
class Ambient {
    color;
    intensity;
    light;
    /**
     * Ambient light.
     * @param scene the rendering scene.
     */
    constructor(scene) {
        this.color = new Color(0xffffff);
        this.intensity = 0.5;
        this.light = new AmbientLight(this.color, this.intensity);
        scene.add(this.light);
    }
    get getColor() {
        return this.color;
    }
    set setColor(color) {
        this.color = color;
        this.light.color = this.color;
    }
    get getIntensity() {
        return this.intensity;
    }
    set setIntensity(intensity) {
        this.intensity = intensity;
        this.light.intensity = this.intensity;
    }
}
export { Ambient };
